import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=fd7d7642&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=fd7d7642&prod&module=true&lang=css"
import style1 from "./Main.vue?vue&type=style&index=1&id=fd7d7642&prod&lang=less&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "fd7d7642",
  null
  
)

export default component.exports